



















import { Vue, Component, Prop } from 'vue-property-decorator';
import { lazyInject } from '@/app/container';
import { EventStream, EventStreamSymbol } from '@/app/event-stream/event-stream';
import { StatisticsUpdated, StatisticsUpdatedEventName } from '@/app/statistics/events/section-interaction-events';
import { SectionCompletion } from '@/app/statistics/section/section-progress';
import { getPageLocationByHref } from '@/app/shared/utils/route-utils';
import { tocHrefEqualsPage } from '@/app/aspect/toc-utils';
import sectionStoreModule from '@/app/statistics/state/section-state';

@Component
export default class BottomNavigationComponent extends Vue {
  @Prop()
  public pages: string[];

  public prevPage: string|null = null;
  public nextPage: string|null = null;

  public pageCompleted: boolean = false;

  @lazyInject(EventStreamSymbol)
  private eventStream: EventStream;

  private listenerId: string|null = null;

  public get currentPage(): string {
    return this.$route.params.page;
  }

  public get currentSectionId(): string|null {
    return sectionStoreModule.currentSectionId;
  }

  public mounted(): void {
    this.calculatePages();

    this.listenPageCompleted();
  }

  public destroyed(): void {
    if (this.listenerId !== null) {
      this.eventStream.removeListener(StatisticsUpdatedEventName, this.listenerId);
    }
  }

  public getPageLocationByHref(href: string) {
    return getPageLocationByHref(href);
  }

  private calculatePages(): void {
    const currentIndex: number = this.calculateCurrentIndex(this.currentPage);
    if (currentIndex > 0) {
      this.prevPage = this.pages[currentIndex - 1];
    } else {
      this.prevPage = null;
    }

    if (this.pages.length > currentIndex + 1) {
      this.nextPage = this.pages[currentIndex + 1];
    } else {
      this.nextPage = null;
    }
  }

  private calculateCurrentIndex(currentPage: string): number {
    return this.pages.findIndex((page: string) => tocHrefEqualsPage(currentPage, page));
  }

  private listenPageCompleted(): void {
    this.listenerId = this.eventStream.listen(StatisticsUpdatedEventName, (payload: StatisticsUpdated) => {
      const completion: SectionCompletion = payload.completion;
      if (completion.progress.completion === 100) {
        this.pageCompleted = true;
      }
    });
  }
}
